import React from 'react';

function IconSvg({ children }: { children: React.ReactNode }) {
  return (
    <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden focusable="false">
      {children}
    </svg>
  );
}

const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round' as const };

export function TableEditIconRowInsertAbove() {
  return (
    <IconSvg>
      <path {...stroke} d="M5 9h14M12 5v8M9.5 7.5 12 5l2.5 2.5" />
      <path {...stroke} d="M5 14h14M5 17h14" />
    </IconSvg>
  );
}

export function TableEditIconRowInsertBelow() {
  return (
    <IconSvg>
      <path {...stroke} d="M5 7h14M5 10h14" />
      <path {...stroke} d="M5 15h14M12 11v8M9.5 16.5 12 19l2.5-2.5" />
    </IconSvg>
  );
}

export function TableEditIconRowDelete() {
  return (
    <IconSvg>
      <path {...stroke} d="M5 8h14M5 11h14M5 14h14M5 17h14" />
      <path {...stroke} d="M4 11h16" />
    </IconSvg>
  );
}

export function TableEditIconColInsertLeft() {
  return (
    <IconSvg>
      <path {...stroke} d="M9 5v14M14 5v14M19 5v14" />
      <path {...stroke} d="M6 12H2M4.5 9.5 2 12l2.5 2.5" />
    </IconSvg>
  );
}

export function TableEditIconColInsertRight() {
  return (
    <IconSvg>
      <path {...stroke} d="M5 5v14M10 5v14M15 5v14" />
      <path {...stroke} d="M18 12h4M21.5 9.5 18 12l3.5 2.5" />
    </IconSvg>
  );
}

export function TableEditIconColDelete() {
  return (
    <IconSvg>
      <path {...stroke} d="M7 5v14M12 5v14M17 5v14" />
      <path {...stroke} d="M6 12h12" />
    </IconSvg>
  );
}

export function TableEditIconMergeCells() {
  return (
    <IconSvg>
      <rect x="5" y="6" width="14" height="12" rx="1.2" {...stroke} />
      <path {...stroke} d="M5 12h14" />
      <path {...stroke} d="M12 6v6" />
    </IconSvg>
  );
}

export function TableEditIconSplitCell() {
  return (
    <IconSvg>
      <rect x="5" y="6" width="14" height="12" rx="1.2" {...stroke} />
      <path {...stroke} d="M12 6v12M5 12h14" />
    </IconSvg>
  );
}

export function TableEditIconClearContent() {
  return <img src="/Eraser.svg" alt="" width={18} height={18} aria-hidden />;
}

export const TABLE_TEXT_ALIGN_ICON_PATHS: Record<'left' | 'center' | 'right', React.ReactNode> = {
  left: <path fill="currentColor" d="M4 6h16v2H4V6zm0 5h11v2H4v-2zm0 5h16v2H4v-2z" />,
  center: <path fill="currentColor" d="M4 6h16v2H4V6zm3 5h10v2H7v-2zm-3 5h16v2H4v-2z" />,
  right: <path fill="currentColor" d="M4 6h16v2H4V6zm5 5h11v2H9v-2zM4 16h16v2H4v-2z" />,
};

export const TABLE_VERTICAL_ALIGN_ICON_SRCS: Record<'top' | 'middle' | 'bottom', string> = {
  top: '/iconstack.iTextbox%20Top.svg',
  middle: '/iconstack.iTextbox%20Middle.svg',
  bottom: '/iconstack.iTextbox%20Bottom.svg',
};

export function TableEditIconTextColor() {
  return (
    <IconSvg>
      <path
        fill="currentColor"
        d="M6 18h12l-1.2-3H7.2L6 18zm3.1-5h5.8L12 7.5 9.1 13z"
      />
      <path fill="currentColor" d="M6 20h12v1.5H6V20z" opacity="0.55" />
    </IconSvg>
  );
}

export function TableEditIconBackgroundColor() {
  return (
    <IconSvg>
      <rect x="5" y="5" width="14" height="14" rx="1.5" fill="currentColor" opacity="0.22" />
      <rect x="5" y="5" width="14" height="14" rx="1.5" {...stroke} />
    </IconSvg>
  );
}

export function TableEditIconBorderColor() {
  return (
    <IconSvg>
      <rect x="5.5" y="5.5" width="13" height="13" rx="1.2" {...stroke} strokeWidth={2.2} />
    </IconSvg>
  );
}

export function TableEditIconBorderWidth() {
  return (
    <IconSvg>
      <rect x="5" y="7" width="14" height="10" rx="1" {...stroke} strokeWidth={1} />
      <rect x="5" y="7" width="14" height="10" rx="1" {...stroke} strokeWidth={2.5} />
    </IconSvg>
  );
}
